import { ISaveJobPostDetailPayload } from '../types';
import { PermanentJobsApi } from '../clients';

export const saveJobPostDetail = async (
  id: string,
  payload: Partial<ISaveJobPostDetailPayload>,
): Promise<void> => {
  await PermanentJobsApi.saveJobPostDetail(id, payload);
};
